<template>
  <div class="editFormDataModal">
    <b-modal
      ref="modal"
      hide-footer
      centered
      :title="title"
      size="xl"
      @shown="getFormData"
    >

      <div class="save-button-wrapper">
        <b-button variant="primary" @click="save">
          Save
        </b-button>
      </div>
      <DataGridFormBuilder
        v-if="formData"
        type="template"
        :form="formData"
        :options="options"
        :gridId="gridId"
        :rowKey="rowKey"
        ref="form"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import extOpts from './extension-options'
// components
import DataGridFormBuilder from '@/components/DataGrid/FormBuilder'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  components: {
    DataGridFormBuilder
  },
  data () {
    return {
      gridId: null,
      options: extOpts,
      formData: null
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options'
    ]),
    title () {
      if (!this.exists()) return null

      const gridTitle = this.dataGrid_options[this.gridId].title

      return `Edit form data for "${gridTitle}" DataGrid`
    }
  },
  methods: {
    open (gridId, rowKey) {
      this.gridId = gridId
      this.rowKey = rowKey

      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    exists () {
      if (!this.gridId || !this.dataGrid_options) return false
      if (!this.dataGrid_options[this.gridId]) return false
      return true
    },
    save (keepOpened) {
      db.dataGrid.options.saveRowEditorForm(this.gridId, this.formData, () => {
        if (!keepOpened) this.close()

        this.$bvToast.toast('Form settings saved.', {
          title: 'Success!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 2500,
        })
        eventBus.$emit(`dgForm-${this.gridId}-updated`)
      })
      this.close();
    },
    getFormData () {
      if (!this.exists()) return null

      try {
        this.formData = JSON.parse(this.dataGrid_options[this.gridId].rowEditorFieldsForm)
      } catch (err) {
        console.log('problem loading form json')
       // console.error(err)

        this.formData = null
      }
    }
  },
  created () {
    //console.log('edit datagrid modal')
    eventBus.$on('showDataGridEditFormDataModal', (gridId, rowKey) => {
      this.open(gridId, rowKey)
    })
  }
}
</script>

<style>
.form-builder-template .accordion .card-header:after {
  display: none !important;
}
.save-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  padding-right: 15px;
}
</style>
